export default function isScreenMobile(input: string): boolean {
  const mediaQueryList = window.matchMedia(`(max-width: ${input || '767px'})`);
  return mediaQueryList.matches;
}
